module.exports = __webpack_public_path__ + "img/temperature-empty.ad843c34.svg";